import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { LayerNames } from "game-layers";
import { wrapperImplementation } from "gameiom/wrapper/wrapper-implementation";
import { FreespinIdleState } from "slotworks/state-machine/standard/states/freespin-idle-state";

export class AgsFreespinIdleState extends FreespinIdleState {
    protected skipQueued: boolean;
    protected completeQueued: boolean;
    protected waitingForOnResume: boolean;

    public onEnter(): void {
        this.changeBackground();
        this.skipQueued = false;
        this.completeQueued = false;
        this.waitingForOnResume = false;

        // Don't call setIdle or winningsUpdate before first freespin, rollup will have handled that
        if (gameState.getCurrentGame().getFreespinsPlayed() > 0) {
            const currentGame = gameState.getCurrentGame()
            const win = currentGame.getTotalWin();

            if(win > 0) {
                gameWrapper.winningsUpdate(win);
            }


            this.waitingForOnResume = true;
            wrapperImplementation.onResume.addOnce(() => this.onResume());
            gameWrapper.setIdle();
        }

        super.onEnter();
    }

    public complete(): void {
        if (this.waitingForOnResume) {
            this.completeQueued = true;
        } else {
            super.complete();
        }
    }

    public skip(): void {
        if (this.waitingForOnResume) {
            this.skipQueued = true;
        } else {
            super.skip()
        }
    }

    protected onResume() {
        this.waitingForOnResume = false;

        if (this.skipQueued) {
            this.skip();
        } else if (this.completeQueued) {
            this.complete();
        }
    }

    protected changeBackground(): void {
        if (Layers.get(LayerNames.Background).hasScene("freespins")) {
            Layers.get(LayerNames.Background).setScene("freespins").execute();
        }
    }
}